import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Box,
  Icon,
  Text,
  Flex,
  Grid,
  GridItem,
  useToast
} from '@chakra-ui/react';
import { FaEdit } from 'react-icons/fa';
import { Input } from '../../../../../../components/Inno/Input';
import * as T from '../../../../../../components/Table';
import { Item } from './Item';
import { Button } from '../../../../../../components/Button';
import { useEffect, useState } from 'react';
import { api } from '../../../../../../services/api';
import { useParams } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';

async function updateFormaDePagamento({ numero_nota, id_venda }) {
  const response = await api.put('/site/v2/orcamento-crm/atualiza-forma-pagamento', {
    numero_nota,
    id_venda
  });

  return response.data;
}

export function ModalFormaPagamento({ formasPagamento, defaultValue, numeroNota }) {
  const INITIAL_VALUE = formasPagamento?.find((item) => item.id_venda === defaultValue);

  const [formaPagamentoSelected, setFormaPagamentoSelected] = useState(null);
  const { numeroProposta: numProposta } = useParams();

  const { isOpen, onOpen, onClose } = useDisclosure();
  function handleSetFormaDePagamento(formaPagamento) {
    setFormaPagamentoSelected(formaPagamento);
    // onClose()
  }

  const toast = useToast({
    isClosable: true,
    position: 'top-right',
    duration: 5000
  });

  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: updateFormaDePagamento,
    onSuccess: (data) => {
      queryClient.setQueryData(['items', numProposta], (oldData) => {
        return {
          ...oldData,
          id_pagamento: data.id_venda,
          informacao_da_proposta: {
            ...oldData.informacao_da_proposta,
            id_pagamento: data.id_venda
          }
        };
      });

      toast({
        title: 'Forma de pagamento atualizada com sucesso!',
        status: 'success'
      });
      onClose();
    }
  });

  async function handleUpdateFormaDePagamento() {
    await mutateAsync({
      numero_nota: numeroNota,
      id_venda: formaPagamentoSelected.id_venda
    });
  }

  const totalInfoPayment = formasPagamento?.length;

  useEffect(() => {
    setFormaPagamentoSelected(INITIAL_VALUE);
  }, [INITIAL_VALUE]);

  return (
    <>
      <Box
        py={1}
        px={4}
        bg="#EDF2F7"
        onClick={onOpen}
        cursor="pointer"
        display="flex"
        alignItems="center"
        justifyContent="space-between">
        <Flex alignItems="center" gap={2}>
          <Text fontWeight="bold" whiteSpace="nowrap">
            Forma de pagamento:
          </Text>
          <Text maxW="75px" isTruncated>
            {formaPagamentoSelected?.tipo_pagamento}
          </Text>
        </Flex>
        <Icon as={FaEdit} color="#378BBF" ml={1} />
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} size="full">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            textTransform="uppercase"
            textAlign="center"
            bg="#F5F5F5"
            color="#378BBF"
            fontWeight="bold">
            Forma de Pagamento
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody display="flex" flexDir="column" alignItems="center" w="100%">
            <Box ml="auto" display="flex" gap={2} alignItems="center" my={10}>
              <Input label="BUSCAR POR CÓDIGO" />
              <Button bgColor="#378BBF" color="white" _hover={{ filter: 'brightness(.9)' }}>
                Buscar
              </Button>
            </Box>

            <Grid gridTemplateColumns="repeat(2, 1fr)" maxW="1151px" w="full" mx="auto" gap={8}>
              <GridItem>
                <T.Table variant="outline">
                  <T.Thead>
                    <T.Tr>
                      <T.Th />
                      <T.Th>Código</T.Th>
                      <T.Th textAlign="start">Forma de Pagamento</T.Th>
                    </T.Tr>
                  </T.Thead>
                  <T.Tbody>
                    {formasPagamento
                      ?.slice(0, Math.ceil(totalInfoPayment / 2))
                      .map((item, index) => (
                        <Item
                          key={index}
                          striped={index % 2 === 0}
                          item={item}
                          selectedItem={formaPagamentoSelected === item}
                          setSelectedItem={handleSetFormaDePagamento}
                        />
                      ))}
                  </T.Tbody>
                </T.Table>
              </GridItem>
              <GridItem>
                <T.Table variant="outline">
                  <T.Thead>
                    <T.Tr>
                      <T.Th />
                      <T.Th>Código</T.Th>
                      <T.Th textAlign="start">Forma de Pagamento</T.Th>
                    </T.Tr>
                  </T.Thead>
                  <T.Tbody>
                    {formasPagamento
                      ?.slice(Math.ceil(totalInfoPayment / 2), totalInfoPayment)
                      .map((item, index) => (
                        <Item
                          key={index}
                          striped={index % 2 === 0}
                          item={item}
                          selectedItem={formaPagamentoSelected === item}
                          setSelectedItem={handleSetFormaDePagamento}
                        />
                      ))}
                  </T.Tbody>
                </T.Table>
              </GridItem>
            </Grid>
          </ModalBody>

          <ModalFooter>
            <Button onClick={handleUpdateFormaDePagamento} isLoading={isLoading}>
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
